import { render, staticRenderFns } from "./teamsDonation.vue?vue&type=template&id=4cdf90b4&scoped=true&"
import script from "./teamsDonation.vue?vue&type=script&lang=js&"
export * from "./teamsDonation.vue?vue&type=script&lang=js&"
import style0 from "./teamsDonation.vue?vue&type=style&index=0&id=4cdf90b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdf90b4",
  null
  
)

export default component.exports